import React from "react";
import { connect } from "react-redux";
import { navigate } from "gatsby";

import Footer from "../../components/Footer/DefaultFooter";
import Header from "../../components/Header/AppHeader";
import Helmet from "../../components/Helmet";
import Loader from "../../components/Loader";
import { updateMe } from "../../state/global";
import * as sessions from "../../utils/sessions";
import isBrowser from "../../utils/isBrowser";

import "../base.css";

const AppLayout = ({ children, me, updateMe, title, description, image }) => {
    React.useEffect(() => {
        if (me && me.token) {
        } else {
            const profile = sessions.getSessionValue(sessions.PROFILE_KEY);
            if (profile && profile.token) {
                updateMe(profile);
            } else {
                navigate(isBrowser() ? "/authorize?path=" + window.location.pathname : "/authorize");
            }
        }
    }, [ me, updateMe ]);

    return (
        me && me.token
        ?   <div>
                <Helmet
                    title={ title }
                    description={ description }
                    image={ image }
                />
                <Header />
                <main
                    css={{
                        margin: "0 auto",
                        padding: 15,
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "calc(100vh)",
                        maxWidth: 1000,
                    }}
                >
                    { children }
                </main>
                <Footer />
            </div>
        :   <div css={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                width: "100vw",
            }}>
                <Loader />
            </div>
    );
};

export default connect(
    state => ({ me: state.global.me }),
    dispatch => ({ updateMe: me => dispatch(updateMe(me)) }),
)(AppLayout);
